import React from "react";

import { hasQuery } from "utils/productSearch";

function ProductSearch({
  id,
  value,
  onChange,
  placeholder,
  label,
  noun,
  resultCount,
  totalCount,
  hint,
}) {
  const query = value != null ? value : "";
  const isSearching = hasQuery(query);
  const items = noun != null ? noun : "items";

  const handleKeyDown = (e) => {
    if (e.key === "Escape" && isSearching) {
      e.preventDefault();
      onChange("");
    }
  };

  return (
    <div className="hm-search">
      <div className="hm-search-wrap">
        <i className="now-ui-icons ui-1_zoom-bold hm-search-ico" aria-hidden="true"></i>
        <input
          id={id}
          className="hm-search-i"
          type="search"
          autoComplete="off"
          value={query}
          placeholder={placeholder}
          aria-label={label}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        {isSearching && (
          <button
            className="hm-search-x"
            type="button"
            aria-label="Clear search"
            onClick={() => onChange("")}
          >
            <span aria-hidden={true}>×</span>
          </button>
        )}
      </div>
      <p className="hm-search-note" role="status" aria-live="polite">
        {isSearching
          ? "Showing " + resultCount + " of " + totalCount + " " + items
          : totalCount + " " + items}
        {isSearching && hint && <span className="hm-search-hint">{hint}</span>}
      </p>
    </div>
  );
}

export default ProductSearch;
